'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _instagramDemographicsCountriesTable = require('../instagram-demographics-countries-table');

var _instagramDemographicsCountriesTable2 = _interopRequireDefault(_instagramDemographicsCountriesTable);

var _demographicsLocationTable = require('../demographics-location-table');

var _demographicsLocationTable2 = _interopRequireDefault(_demographicsLocationTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAB_STYLES = {
  marginBottom: 4
};
var MODAL_LINK_STYLE = {
  cursor: 'pointer'
};

var getPanes = function getPanes(props) {
  var audienceCities = props.audienceCities,
      audienceLocations = props.audienceLocations,
      onFullCountryClick = props.onFullCountryClick,
      onFullCityClick = props.onFullCityClick;

  var panes = [{
    menuItem: { content: 'Fans by Country', key: 'country', icon: 'globe' },
    render: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Tab.Pane,
        null,
        _react2.default.createElement(_demographicsLocationTable2.default, {
          data: audienceLocations.data,
          metric: 'absolute',
          metricLabel: 'Followers',
          itemLabel: 'Country',
          uniqueKey: 'location'
        }),
        _react2.default.createElement(
          'a',
          { style: MODAL_LINK_STYLE, onClick: onFullCountryClick },
          'View full engagement data'
        )
      );
    }
  }, {
    menuItem: { content: 'Fans by City', key: 'last12posts', icon: 'building outline' },
    render: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Tab.Pane,
        null,
        _react2.default.createElement(_demographicsLocationTable2.default, {
          data: audienceCities.data,
          metric: 'absolute',
          metricLabel: 'Followers',
          itemLabel: 'City',
          uniqueKey: 'location'
        }),
        _react2.default.createElement(
          'a',
          { style: MODAL_LINK_STYLE, onClick: onFullCityClick },
          'View full engagement data'
        )
      );
    }
  }];
  return panes;
};

var InstagramTabs = function InstagramTabs(props) {
  var audienceCities = props.audienceCities;

  if (audienceCities) {
    return _react2.default.createElement(_semanticUiReact.Tab, { style: TAB_STYLES, panes: getPanes(props) });
  }
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h5',
      null,
      'Fans by Country'
    ),
    _react2.default.createElement(_instagramDemographicsCountriesTable2.default, props)
  );
};

InstagramTabs.propTypes = {
  audienceCities: _propTypes2.default.Object
};
InstagramTabs.defaultProps = {
  audienceCities: undefined
};

exports.default = InstagramTabs;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-profile-data/location-tabs.js
 ** module id = 2592
 ** module chunks = 0
 **/